import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, map, distinctUntilChanged, startWith, tap } from 'rxjs/operators';
import { EScreenMedia } from '../../../enumerables/screenMedia';
import { Parameter } from 'projects/common/src/app/classes';

@Injectable({
  providedIn: 'root'
})
export class ScreenMediaService extends Parameter<number> {

  private readonly SCREEN_SIZE = {
    xs: [0, 576.98],
    sm: [576, 767.98],
    md: [768, 991.98],
    lg: [992, 1199.98],
    xl: [1200, 999999]
  };

  constructor() {
    super();
    this.name = 'screen-media';
  }

  public start(): Promise<number> {
    return new Promise((resolve) => {
      fromEvent(window, 'resize').pipe(
        debounceTime(100),
        map(() => window.innerWidth),
        distinctUntilChanged(),
        startWith(window.innerWidth),
        tap((width: number) => this.set(this.matchScreen(width)))
      ).subscribe();
      resolve();
    });
  }

  private matchScreen(width: number): EScreenMedia {
    for (const key in this.SCREEN_SIZE) {
      if (this.SCREEN_SIZE.hasOwnProperty(key)) {
        const config = this.SCREEN_SIZE[key];
        if (width >= config[0] && width <= config[1]) {
          return EScreenMedia[key];
        }
      }
    }
  }
}
